const membershipDomainRequiredPlacementIds = new Set([
  "get-inspired"
]);

export const requiresMembershipDomain = (placementId?: string): boolean => {
  return typeof placementId === 'string' && membershipDomainRequiredPlacementIds.has(placementId);
}
